import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';

const MobileContactFAB = () => (
  <div className="md:hidden fixed bottom-4 right-4 z-50 flex flex-col gap-3">
    <a
      href="sms:+12533159480"
      aria-label="Text Mazen"
      className="w-14 h-14 rounded-full bg-[#0a0a0a] text-white shadow-lg flex items-center justify-center border border-white/10 active:scale-95 transition-transform"
    >
      <MessageSquare size={22} />
    </a>
    <a
      href="tel:+12533159480"
      aria-label="Call Mazen"
      className="w-14 h-14 rounded-full bg-white text-gray-900 shadow-lg flex items-center justify-center border border-gray-200 active:scale-95 transition-transform"
    >
      <Phone size={22} />
    </a>
  </div>
);

export default MobileContactFAB;
